import { useIonModal } from '@ionic/react'
import { useEffect, useState } from 'react'

import { usePingUnit } from '@apps-common/apis/portal/control'
import {
  AccountStatus,
  ActivationStatus,
  ConnectivityStatus,
  PingButton,
  SignalStatus,
  StatusInfoModal
} from '@apps-common/apps/portal/pages/units/pages/manage/components'
import { ButtonRoundSm } from '@apps-common/components/elements'
import { commonIcons } from '@apps-common/config/icons'
import { unitIsActive, unitIsCancelled, unitIsInactive } from '@apps-common/helpers/unit-helpers'
import { defaultModalAnimations } from '@apps-common/lib/modal-animations'
import { IUnitGenericDetailsModel } from '@apps-common/types/portal/unit'
import { DeviceStatus } from '@apps-common/utils/device-status'

interface IProps {
  unit?: IUnitGenericDetailsModel
}

export const UnitStatus = ({ unit }: IProps) => {
  const isCancelled = unitIsCancelled(unit)
  const { isLoading, isFetching, isRefetching, refetch, data } = usePingUnit({
    config: {
      enabled: !!unit?.unitId && !isCancelled
    },
    model: {
      unitId: unit?.unitId || '',
      triggerType: '',
      onTime: 0,
      commands: []
    }
  })

  const [status, setStatus] = useState<DeviceStatus | undefined>()

  const [presentStatusInfoModal, dismissStatusInfoModal] = useIonModal(StatusInfoModal, {
    componentProps: { unit },
    onDismiss: () => {
      dismissStatusInfoModal()
    }
  })

  useEffect(() => {
    if (data && unit) {
      console.log('updatingDeviceStatus.....')
      const statusObj = new DeviceStatus(unit.accountNo, unit.productId, unit.product, unit.imageUrl, data)

      setStatus(statusObj)
    }
  }, [data])

  const isInactive = unitIsInactive(unit)
  const isActive = unitIsActive(unit)

  const loading = !unit || isLoading || isFetching || isRefetching

  return (
    <div className='relative w-full max-w-[420px] sm:w-auto sm:'>
      <div className='relative flex items-center justify-between my-[5px] sm:my-0 gap-[2px] sm:gap-[8px] md:pb-0 md:pl-8'>
        {loading && (
          <div className='absolute top-0 left-0 h-full w-full text-text/30 text-[0.85rem] flex items-center justify-center pr-[64px]'>
            <div className='px-2 py-[3px] bg-surface rounded-full border border-border'>Status check in progress</div>
          </div>
        )}
        {/* <ProductStatus loading={loading} data={status?.model || { imageUrl: unit?.imageUrl || '', name: unit?.product || '' }} /> */}
        <AccountStatus loading={loading} isInactive={isInactive} data={status?.accountNo || unit?.accountNo} />
        <ActivationStatus loading={loading} isInactive={isInactive} isActive={isActive} isCancelled={isCancelled} />
        <ConnectivityStatus loading={loading} data={status?.online} />
        <SignalStatus loading={loading} data={status?.signal} />

        <div className='flex items-center justify-start gap-[5px] bg-surface border border-border p-[7px] rounded-full'>
          <PingButton
            loading={loading}
            refetch={refetch}
            requestModel={{
              unitId: unit?.unitId || '',
              triggerType: '',
              onTime: 0,
              commands: []
            }}
            disabled={isCancelled}
          />
          <ButtonRoundSm
            type='button'
            size='lg'
            className='action-brand'
            disabled={loading || isCancelled}
            callback={() => presentStatusInfoModal(defaultModalAnimations)}
          >
            <commonIcons.info className='text-[1.4rem]' />
          </ButtonRoundSm>
        </div>
      </div>
    </div>
  )
}
